import { render, staticRenderFns } from "./CCTableMappingFields.vue?vue&type=template&id=56eaa7f1"
import script from "./CCTableMappingFields.vue?vue&type=script&lang=js"
export * from "./CCTableMappingFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports